import axios from 'axios';
import { REALM_LIST_URL, KC_MANAGER_URL } from "./config";

const getKcManagerUrl = () => {
  const url = KC_MANAGER_URL || process.env.VUE_APP_KC_MANAGER_URL;
  if (url && url !== 'undefined' && url !== 'null' && String(url).trim() !== '') {
    const trimmed = String(url).trim().replace(/\/+$/, '');
    if (trimmed.includes('/api/v1/public/realms')) {
      return trimmed;
    }
    return `${trimmed}/api/v1/public/realms/`;
  }
  return null;
};

const getFallbackRealmListUrl = () => {
  const fallback = REALM_LIST_URL || process.env.VUE_APP_REALM_LIST_URL;
  if (fallback && fallback !== 'undefined' && fallback !== 'null' && String(fallback).trim() !== '') {
    return fallback;
  }
  return null;
};

let realmListCache = null;

export async function loadRealmList() {
  if (realmListCache && Array.isArray(realmListCache) && realmListCache.length > 0) {
    return realmListCache;
  }

  const primaryUrl = getKcManagerUrl();
  const fallbackUrl = primaryUrl ? null : getFallbackRealmListUrl();

  const urlsToTry = [];
  if (primaryUrl) {
    urlsToTry.push(primaryUrl);
  } else if (fallbackUrl) {
    urlsToTry.push(fallbackUrl);
  }

  for (const url of urlsToTry) {
    try {
      const response = await axios.get(url, { timeout: 10000 });
      let raw = response.data;

      if (typeof raw === 'string') {
        try {
          raw = JSON.parse(raw);
        } catch (e) {
          console.error('Resposta não é JSON válido em realmList:', e);
          continue;
        }
      }

      let parsed = null;
      if (Array.isArray(raw)) {
        parsed = raw;
      } else if (raw && Array.isArray(raw.data)) {
        parsed = raw.data;
      } else if (raw && Array.isArray(raw.realmList)) {
        parsed = raw.realmList;
      }

      if (parsed && Array.isArray(parsed) && parsed.length > 0) {
        realmListCache = parsed;
        return realmListCache;
      }
    } catch (e) {
      console.warn(`Falha ao carregar realmList de ${url}:`, e.message || e);
    }
  }

  return [];
}

export async function getRealmById(realm) {
  const list = await loadRealmList();
  return list.find((item) => item.realm === realm) || null;
}

export async function getRealmByDisplayUrl(displayUrl) {
  const list = await loadRealmList();
  if (!displayUrl) return null;

  const needle = String(displayUrl).toLowerCase();

  return (
    list.find((item) =>
      (item.realm && String(item.realm).toLowerCase() === needle) ||
      (item.displayUrl && String(item.displayUrl).toLowerCase() === needle) ||
      (item.display_url && String(item.display_url).toLowerCase() === needle) ||
      (item.client && String(item.client).toLowerCase() === needle)
    ) || null
  );
}

export async function getClientIdByRealm(realm) {
  const item = await getRealmById(realm);
  return item ? item.client : null;
}

export default {
  loadRealmList,
  getRealmById,
  getRealmByDisplayUrl,
  getClientIdByRealm,
};